import { createFileRoute } from '@tanstack/react-router'
import { Nav } from '@/components/landing/Nav'
import { Hero } from '@/components/landing/Hero'
import { Features } from '@/components/landing/Features'
import { Pricing } from '@/components/landing/Pricing'
import { Footer } from '@/components/landing/Footer'

import { authMiddleware } from '@/server/functions/auth'

export const Route = createFileRoute('/_public/')({
  component: Index,
  loader: async () => {
    const { currentUser } = await authMiddleware()

    return {
      currentUser,
    }
  },
})

function Index() {
  const { currentUser } = Route.useLoaderData()

  return (
    <div className="min-h-screen bg-slate-900">
      <Nav currentUser={currentUser} />
      <Hero currentUser={currentUser} />
      <Features />
      {/* <HowItWorks /> */}
      <Pricing currentUser={currentUser} />
      <Footer />
    </div>
  )
}
